export const clampProgress = (value: number): number =>
  Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0))

export interface ScrollMetrics {
  scrollHeight: number
  scrollY: number
  viewportHeight: number
}

export const getScrollProgress = ({
  scrollHeight,
  scrollY,
  viewportHeight,
}: ScrollMetrics): number => {
  const availableDistance = Math.max(0, scrollHeight - viewportHeight)

  if (availableDistance === 0) {
    return 0
  }

  return clampProgress(scrollY / availableDistance)
}

export const dampProgress = (
  current: number,
  target: number,
  damping: number,
  deltaSeconds: number,
): number => {
  if (deltaSeconds <= 0) {
    return clampProgress(current)
  }

  const blend = 1 - Math.exp(-Math.max(0, damping) * deltaSeconds)
  return clampProgress(current + (target - current) * blend)
}
